import PropTypes from "prop-types";
import { BellRegularV6, XmarkLargeSolidV6 } from "@shared/v2/Icomoon";
import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import Modal from "@shared/v2/Modal";
import { alertDefaultProps, alertPropTypes } from "../listing_alerts/helper";
import CollectionCard from "../listing_alerts/CollectionCard";
import ListingAlertCardView from "../listing_alerts/ListingAlertCardView";

const ViewAllListingAlertsModal = ({
  handleDelete,
  listingAlerts,
  onClose,
  openAddModal,
  openEditModal,
  websiteUrl,
  onDismiss,
  isDismiss,
  onToggleNotification,
  doesLeadHaveApp,
}) => (
  <Modal
    className="tw-flex tw-justify-center tw-items-center"
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[896px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    backdrop="static"
    show
    onHide={onClose}
  >
    <Modal.Header
      className="tw-mx-[10px]"
      titleClassName="tw-text-gray-75"
      title="Listing Alerts"
      closeButton
    />
    <Modal.Body className="tw-overflow-y-scroll">
      <div className="tw-m-[10px]">
        {listingAlerts?.some((alert) => alert?.source === "property_collections") &&
          !isDismiss && (
            <div className="tw-flex tw-items-center tw-justify-between tw-mb-[24px] tw-py-[12px] tw-px-[16px] tw-border-solid tw-border-[1px] tw-text-brand-success tw-border-[#DEF3F3] tw-bg-blue-10 tw-rounded-[4px] tw-flex tw-items-center">
              <div className="tw-text-[12px] tw-leading-[16px] tw-text-brand-success">
                <span className="tw-font-bold">Collections</span> currently uses the Listing Alert feature to
                deliver property updates to leads.
              </div>
              <div className="tw-gap-[16px] tw-flex tw-items-center">
                <Button
                  schema="secondary"
                  onClick={() =>
                    window.open(
                      "https://www.brivityknowledge.com/docs/how-collections-work-in-brivity",
                      "_blank",
                    )
                  }
                >
                  <span>Learn more</span>
                </Button>
                <span className="tw-cursor-pointer" onClick={onDismiss}>
                  <XmarkLargeSolidV6 size="m" />
                </span>
              </div>
            </div>
          )}
        <div className="tw-flex tw-flex-row tw-gap-[24px] tw-flex-wrap">
          <div className="tw-justify-center tw-shadow-card tw-rounded-[6px] tw-p-[16px] tw-flex tw-flex-col tw-h-[220px] tw-w-[254px]">
            <div className="tw-flex tw-justify-center">
              <TextButton size="medium" onClick={openAddModal}>
                <div className="tw-pb-[24px]">
                  <BellRegularV6 className="tw-w-[64px] tw-h-[64px]" />
                </div>
                Create new listing alert
              </TextButton>
            </div>
          </div>
          {listingAlerts.map((alert, alertIndex) =>
            alert?.source === "property_collections" ? (
              <CollectionCard
                customClassName="tw-h-[220px] tw-w-[254px]"
                alert={alert}
                index={alertIndex}
                websiteUrl={websiteUrl}
                onToggleNotification={onToggleNotification}
                doesLeadHaveApp={doesLeadHaveApp}
              />
            ) : (
              <ListingAlertCardView
                customClassName="tw-h-[220px] tw-w-[254px]"
                openEditListingAlertModal={openEditModal}
                openDeleteListingAlertModal={handleDelete}
                alert={alert}
                index={alertIndex}
                websiteUrl={websiteUrl}
              />
            ),
          )}
        </div>
      </div>
    </Modal.Body>
  </Modal>
);

ViewAllListingAlertsModal.propTypes = {
  listingAlerts: PropTypes.arrayOf(alertPropTypes),
  openAddModal: PropTypes.func,
  openEditModal: PropTypes.func,
  onClose: PropTypes.func,
  handleDelete: PropTypes.func,
  websiteUrl: PropTypes.string,
  onDismiss: PropTypes.func,
  isDismiss: PropTypes.bool,
  onToggleNotification: PropTypes.func,
  doesLeadHaveApp: PropTypes.bool,
};
ViewAllListingAlertsModal.defaultProps = {
  listingAlerts: [alertDefaultProps],
  websiteUrl: "",
  handleDelete: null,
  onClose: null,
  openAddModal: null,
  openEditModal: null,
  onDismiss: null,
  isDismiss: false,
  onToggleNotification: null,
  doesLeadHaveApp: false,
};

export default ViewAllListingAlertsModal;
